'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { href: '/#inicio', label: 'Início' },
  { href: '/#servicos', label: 'Serviços' },
  { href: '/#sobre', label: 'Sobre Nós' },
  { href: '/#espaco', label: 'O Espaço' },
  { href: '/#cuidados', label: 'Cuidados' },
  { href: '/#faq', label: 'FAQ' },
  { href: '/#contacto', label: 'Contacto' },
];

export default function SiteHeader() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          isScrolled
            ? 'bg-ivory/95 backdrop-blur-md shadow-sm border-b border-border'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="flex items-center justify-between h-18 lg:h-20">
            {/* Logo */}
            <Link href="/" className="flex flex-col leading-none group">
              <span className="font-serif text-xl lg:text-2xl font-light tracking-[0.15em] text-dark-brown group-hover:text-burnt-rose transition-colors duration-300">
                MÃOS MÁGICAS
              </span>
              <span className="font-sans text-[9px] lg:text-[10px] tracking-[0.35em] text-burnt-rose font-medium uppercase">
                BELEZA · MAPUTO
              </span>
            </Link>

            {/* Desktop Nav */}
            <nav className="hidden lg:flex items-center gap-8">
              {navLinks?.map(link => (
                <Link
                  key={link?.href}
                  href={link?.href}
                  className="text-xs tracking-[0.12em] font-medium uppercase text-foreground/70 hover:text-burnt-rose transition-colors duration-300"
                >
                  {link?.label}
                </Link>
              ))}
            </nav>

            {/* CTA + Mobile Menu */}
            <div className="flex items-center gap-3">
              <a
                href="#agendar"
                className="hidden sm:inline-flex items-center px-5 py-2.5 btn-primary rounded-full text-xs tracking-[0.12em] uppercase font-semibold"
              >
                Agendar Sessão
              </a>
              <button
                onClick={() => setMenuOpen(true)}
                className="lg:hidden p-2 text-foreground/70 hover:text-burnt-rose transition-colors"
                aria-label="Abrir menu"
              >
                <Menu size={22} />
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      {menuOpen && (
        <div className="fixed inset-0 z-[100] bg-ivory flex flex-col">
          <div className="flex items-center justify-between px-6 h-18 border-b border-border">
            <Link href="/" className="flex flex-col leading-none" onClick={() => setMenuOpen(false)}>
              <span className="font-serif text-xl font-light tracking-[0.15em] text-dark-brown">MÃOS MÁGICAS</span>
              <span className="font-sans text-[9px] tracking-[0.35em] text-burnt-rose font-medium uppercase">BELEZA · MAPUTO</span>
            </Link>
            <button
              onClick={() => setMenuOpen(false)}
              className="p-2 text-foreground/70 hover:text-burnt-rose transition-colors"
              aria-label="Fechar menu"
            >
              <X size={22} />
            </button>
          </div>
          <nav className="flex flex-col flex-1 px-6 pt-8 gap-1">
            {navLinks?.map(link => (
              <Link
                key={link?.href}
                href={link?.href}
                onClick={() => setMenuOpen(false)}
                className="py-4 text-sm tracking-[0.12em] font-medium uppercase text-foreground/70 hover:text-burnt-rose border-b border-border/50 transition-colors duration-200"
              >
                {link?.label}
              </Link>
            ))}
          </nav>
          <div className="px-6 pb-10">
            <a
              href="#agendar"
              onClick={() => setMenuOpen(false)}
              className="flex items-center justify-center w-full py-4 btn-primary rounded-full text-sm tracking-[0.12em] uppercase font-semibold"
            >
              Agendar Sessão
            </a>
          </div>
        </div>
      )}
    </>
  );
}
